/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

// * Module summary * //
// => This module will show a success msg when the user subscribed to the newsletter
// => It's not optimal as it does not communicate with Flodesk (those guys do not have an API.......), 
// => Hence it will just wait for ["no form error" + "captcha has disappeared"] to show the success msg

export const infolettre = () => {
    let btn = document.querySelector(".fd-btn");
    if (btn) {
        // * Variables
        const ERROR_FORM_TIMEOUT = 600; // Check after x ms that there is no error in the form
        const CAPTCHA_CHECK_FREQUENCY = 600; // Check every x ms that captcha is gone...
        let successMessage = document.querySelector(".success-message");

        // Detect a click on the Subscribe btn
        btn.addEventListener("click", () => {
            setTimeout(() => {
                // Let's wait for a Flodesk feedback.
                // If there is one, user did not submit as there is an error in the form. Else, we proceed
                if (!document.querySelector(".fd-form-feedback")) {
                    let captchaContainer = document.querySelector(".fd-form-captcha");
                    let captcha = captchaContainer.querySelectorAll(".fd-form-group");

                    // At this point, the form has been submitted, but there may be a captcha
                    // Let's check every now and then to see if there is one.
                    // If so, check again, if not, we can show the success msg
                    let myInterval = setInterval(() => {
                        btn.remove();
                        captchaContainer.classList.add("active");

                        let active = false; // Captcha presence
                        for (let current of captcha) {
                            if (window.getComputedStyle(current, null).display != "") {
                                active = true;
                            }
                        }
                        if (!active) {
                            successMessage.style.display = "block";
                            clearInterval(myInterval);
                        }
                    }, CAPTCHA_CHECK_FREQUENCY); 
                }
            }, ERROR_FORM_TIMEOUT);
        });
    }

    return;
};
